import React from 'react';
import { Box, Flex } from 'rebass';
import { Menu, Profile } from '@nike/nike-design-system-icons';
import { nike } from '@nike/nike-design-tokens';
import { useOktaAuth } from '@okta/okta-react';

import IconMenu from '../../components/IconMenu';
import { Icon } from '../../components';
import { TranslatedCopy } from '../../intl';

import logout from '../../util/logout';

const { podiumCdsColorTextPrimaryInverse } = nike;

/**
 * @name getGamedayUrl
 * @desc Gets the url to return back Gameday based on current environment
 */
const getGamedayUrl = () => {
  let env = '';

  if (import.meta.env.VITE_BUILD_ENV !== 'prd') {
    env = `-${import.meta.env.VITE_BUILD_ENV}`;
  }

  return `https://gameday${env}.nike.net`;
};

export const Header = () => {
  const { oktaAuth } = useOktaAuth();

  const handleLogout = async () => {
    await logout(oktaAuth);
  };

  return (
    <Flex className='bg-black p3-sm' justifyContent='space-between'>
      <Flex width='250px' justifyContent='space-between'>
        <Box ml='20px'>
          <IconMenu
            Icon={() => <Menu style={{ color: podiumCdsColorTextPrimaryInverse }} />}
            align='left'
            menuOptions={[
              { text: 'Account Management', to: '/accounts' },
              { text: 'Catalog Types', to: '/catalogTypes' },
              { text: 'Catalogs', to: '/catalogs' },
              { text: 'Departments', to: '/departments' },
              { text: 'Order Issues', to: '/orderIssues' },
              { text: 'Outage Notifications', to: '/notifications' },
              { text: 'Product Contract Groups', to: '/productContractGroups' },
              { text: 'Products', to: '/products' }
            ]}
            openOnHover
          />
        </Box>

        <a href={`${getGamedayUrl()}`} className='flex-container row'>
          <Icon name='chevron-left-cell' alt='left' isLight />
          <div className='headline-5 text-color-primary-light'>
            <TranslatedCopy id='global.backToGameday' />
          </div>
        </a>
      </Flex>
      <Box style={{ color: podiumCdsColorTextPrimaryInverse }} width='385px' pl='30px'>
        <div className='headline-5'>
          <TranslatedCopy id='admin.systemManagement' />
        </div>
      </Box>
      <Box style={{ color: podiumCdsColorTextPrimaryInverse }}>
        <div className='headline-4'>
          <IconMenu Icon={Profile} align='right' menuOptions={[{ text: 'Logout', onClick: handleLogout }]} />
        </div>
      </Box>
    </Flex>
  );
};

export default Header;
